import axios from 'axios';

import { extractData, logError } from '@/api/ApiHelpers';

import type {
	BaselineAction,
	BaselineChangeStatusResponse,
	BaselineGetListResponse,
} from '@/api/ApiTypes';


const baselineGetList = (
	handler: (responseData: BaselineGetListResponse) => void,
): void => {
	axios.get('/baseline/get_list/').then(extractData(handler)).catch(logError);
};


const baselineChangeStatus = (
	id: number,
	action: BaselineAction,
	handler: (responseData: BaselineChangeStatusResponse) => void,
): void => {
	axios.post('/baseline/change_status/', { id, action }).then(extractData(handler)).catch(logError);
};


export default {
	baselineGetList,
	baselineChangeStatus,
};
